import React from 'react';
import PropTypes from 'prop-types';
import { Message, Modal } from 'semantic-ui-react';

const defaultHeader = 'Ett fel uppstod';
const defaultBody = 'Försök igen eller ladda om sidan helt. Kontakta oss om problemet kvarstår: hej@propida.se eller 0707900952';

export const ERROR_MESSAGES = Object.freeze({
  NO_ORDER: {
    header: 'Inget ärende kunde hittas',
    message: 'Ärendet kan antingen ha tagits bort, avvisats eller förfallit.',
  },
  RESTRICTED_ORDER: {
    header: 'Du har inte tillgång till detta ärende',
    message: 'Din behörighet tillåter dig inte att se på detta ärende. Kontakta administratören om du anser att detta är fel.',
  },
  OFFERED_OTHER_COMPANY: {
    header: 'Inget ärende kunde hittas',
    message: 'Ärendet är inte längre aktuell eftersom ett annat företag har accepterat uppdraget.',
  },
  ORDER_CONFIRM_WRONG_STATE: {
    header: 'Ärendet kunde inte bekräftas',
    message: 'Ärendet har antingen blivit borttaget eller redan bekräftat.',
  },
  EMAIL_IN_USE: {
    header: 'E-postadressen används redan',
    message: 'Använd en annan e-postadress',
  },
  LOGIN_FAILED: {
    header: 'Inloggningen misslyckades',
    message: 'Felaktig e-postadress eller lösenord. Kontrollera dina uppgifter och försök igen.',
  },
  LOGIN_PASSWORD_NOT_SET: {
    header: 'Inloggningen misslyckades',
    message: 'Du har inte satt ett lösenord än. Följ länken i välkomstmailet du fick, eller tryck på "Glömt lösenord" och följ instruktionerna.',
  },
  // Notification Channels
  FETCH_CHANNELS_ERROR: {
    header: 'Kunde inte hämta inställningar',
    message: 'Det gick inte att hämta inställningar för notiser. Försök igen eller kontakta support.',
  },
  ENABLE_CHANNEL_ERROR: {
    header: 'Kunde inte aktivera notiser',
    message: 'Det gick inte att aktivera notiser. Försök igen eller kontakta support.',
  },
  DISABLE_CHANNEL_ERROR: {
    header: 'Kunde inte inaktivera notiser',
    message: 'Det gick inte att inaktivera notiser. Försök igen eller kontakta support.',
  },
  CHANNEL_NOT_FOUND: {
    header: 'Inställningar kunde inte hittas',
    message: 'Inställningar för notiser kunde inte hittas. Försök igen eller kontakta support.',
  },
  VERIFY_CHANNEL_ERROR: {
    header: 'Kunde inte verifiera notiser',
    message: 'Det gick inte att verifiera inställningar för notiser. Försök igen eller kontakta support.',
  },
  SEND_CODE_ERROR: {
    header: 'Kunde inte skicka kod',
    message: 'Det gick inte att skicka verifieringskod. Försök igen.',
  },
  MOBILE_NUMBER_REQUIRED: {
    header: 'Mobilnummer krävs',
    message: 'Du måste först lägga till ett mobilnummer för att aktivera WhatsApp-notiser.',
  },
  VERIFICATION_CODE_NOT_FOUND: {
    header: 'Ingen verifieringskod',
    message: 'Ingen verifieringskod hittades. Begär en ny kod.',
  },
  VERIFICATION_CODE_EXPIRED: {
    header: 'Koden har gått ut',
    message: 'Verifieringskoden har gått ut. Begär en ny kod.',
  },
  VERIFICATION_TOO_MANY_ATTEMPTS: {
    header: 'För många försök',
    message: 'Du har gjort för många misslyckade försök. Begär en ny kod.',
  },
  VERIFICATION_CODE_INVALID: {
    header: 'Felaktig kod',
    message: 'Verifieringskoden är felaktig. Försök igen.',
  },
  VERIFICATION_SEND_FAILED: {
    header: 'Kunde inte skicka kod',
    message: 'Det gick inte att skicka verifieringskod. Försök igen.',
  },
  VERIFICATION_NOT_SUPPORTED: {
    header: 'Verifiering stöds ej',
    message: 'Verifiering stöds inte för denna typ av notis.',
  },
  UPDATE_MOBILE_ERROR: {
    header: 'Kunde inte uppdatera mobilnummer',
    message: 'Ett fel uppstod när mobilnumret skulle uppdateras.',
  },
  RESET_PASSWORD_FAILED: {
    message: 'Det gick inte att återfå ett lösenord just nu. Var vänlig kontakta support.',
  },
  PASSWORD_RESET_MISMATCH: {
    message: 'Lösenorden stämde inte överens med varandra',
  },
  PASSWORD_RESET_INVALID: {
    message: 'Lösenordet uppfyller inte minimumkraven (minst 8 tecken varav en siffra)',
  },
  PASSWORD_RESET_NOT_FOUND: {
    message: 'Ingen lösenordsåterställning är påbörjad eller så har du redan satt ett nytt lösenord. Prova att logga in med ditt lösenord eller tryck på "Logga in" och sedan "Glömt lösenord" och följ instruktionerna.',
  },
  PASSWORD_RESET_INVALID_TOKEN: {
    message: 'Du har kommit hit med en felaktig länk. Kontrollera att du använt rätt länk för att återställa lösenordet, alternativt begär ett nytt lösenord genom att trycka på "Logga in" och sedan "Glömt lösenord" och följ instruktionerna.',
  },
  PASSWORD_RESET_EXPIRED: {
    message: 'Länken för att sätta ett lösenord har löpt ut. Tryck på "Logga in" och sedan "Glömt lösenord" och följ instruktionerna.',
  },
  PASSWORD_RESET_ERROR: {
    message: 'Något gick fel när lösenordet skulle sättas. Kontakta support.',
  },
  LOGIN_FAILED_TENANT: {
    header: 'Felaktig länk',
    message: 'Du har antagligen kommit hit genom en felaktig länk.',
  },
  LOGIN_FAILED_EXTCO: {
    header: 'Felaktig länk',
    message: 'Du har antagligen kommit hit genom en felaktig länk.',
  },
  EXTCO_ALREADY_REGISTERED: {
    header: 'Redan registrerat',
    message: 'Ert företag har redan registrerat ett konto. Logga in i systemet för att hitta ordern.',
  },
  EXTCO_ALREADY_APPLIED: {
    header: 'Redan registrerat',
    message: 'Ert företag har redan ansökt eller är redan registrerat.',
  },
  EXTCO_OTHER_CONTRACTOR: {
    header: 'Order redan tagen',
    message: 'En annan entreprenör har redan accepterat ordern.',
  },
  USER_CREATE_FAILED_EXTCO: {
    header: 'Ett fel uppstod',
    message: 'Det uppstod ett fel vid registrering. Var god kontakta hej@propida.se',
  },
  EXTCO_AUTH_FAILED: {
    header: 'Ett fel uppstod',
    message: 'Det uppstod ett fel. Var god försök igen eller kontakta hej@propida.se',
  },
  INTERNAL_SERVER_ERROR: {
    header: defaultHeader,
    message: defaultBody,
  },
  PROPERTY_CREATE_NO_OWNER: {
    message: 'Vald ägare kunde inte hittas. Var vänlig kontakta support.',
  },
  PROPERTY_NOT_FOUND: {
    message: 'Kunde inte hitta fastigheten.Försöker igen eller kontakta support.',
  },
  STRUCTURE_CREATE_NO_PROPERTY: {
    message: 'Vald fastighet kunde inte hittas. Var vänlig kontakta support.',
  },
  STRUCTURE_CREATE_NO_PROPERTY_TAX_TYPE: {
    message: 'Vald typ av fastighet kunde inte hittas. Var vänlig kontakta support.',
  },
  COMPANY_ALREADY_EXISTS: {
    header: 'Redan registrerat',
    message: 'Företag finns redan registrerat.',
  },
  NOAUTH_GENERIC: {
    header: 'Ett fel uppstod',
    message: 'Det uppstod ett fel. Var god försök igen eller kontakta hej@propida.se',
  },
  AGREEMENT_ALREADY_EXISTS: {
    header: 'Redan registrerat',
    message: 'Detta avtalsnamn finns redan registrerat. Vänligen välj ett annat namn',
  },
  AGREEMENT_DO_NOT_EXISTS: {
    header: 'Inget avtal kunde hittas',
  },
  STATISTICS_ERROR: {
    header: 'Ett fel uppstod',
    message: 'Det uppstod ett fel vid hämtning av statistik. Var god försök igen eller kontakta support',
  },
  INTEGRATION_NO_STATE: {
    header: 'Ett fel uppstod med att skapa integrationen',
    message: 'Du kan ha kommit hit med en felaktig länk eller så har du använt samma länk två gånger. Prova att gå till integrationer för att se om den skapats korrekt redan.',
  },
  INTEGRATION_REFRESH_TOKEN_EXPIRED: {
    header: 'Ett fel uppstod vid anslutning mot integration',
    message: 'Gå till inställningar / integrationer och säkerställ att kopplingen till integrationen fungerar.',
  },
  NO_ARTICLE: {
    header: 'Ingen artikel kunde hittas',
    message: 'Artikeln kan ha tagits bort eller flyttats.',
  },
  FAULT_REPORT_INVALID_CLIENT: {
    header: 'Felaktig länk',
    message: 'Du har antagligen kommit hit genom en felaktig länk. Kontrollera att du har rätt länk och försök igen.',
  },
  ARTICLE_NUMBER_EXISTS: {
    header: 'Artikelnummer redan använt',
    message: 'Artikelnumret används redan. Vänligen välj ett annat nummer.',
  },
  COULD_NOT_GENERATE_PDF: {
    header: 'PDF-generering misslyckades',
    message: 'Försök igen eller kontakta support om problemet kvarstår.',
  },
  REDIRECT_TOKEN_EXPIRED: {
    message: 'Länken har tyvärr gått ut och är inte giltig längre.',
  },
  REDIRECT_INVALID_TOKEN: {
    message: 'Länken är tyvärr inte giltig.',
  },
  ORDER_PREFIX_EXISTS: {
    header: 'Orderprefix används redan',
    message: 'Detta orderprefix används redan av en annan kund. Vänligen välj ett annat orderprefix.',
  },
  ORDER_PREFIX_REQUIRED: {
    header: 'Orderprefix krävs',
    message: 'Du måste ange ett orderprefix.',
  },
  REGISTRATION_NUMBER_EXISTS: {
    header: 'Organisationsnummer redan registrerat',
    message: 'Detta organisationsnummer är redan registrerat. Kontrollera att du har angett rätt nummer.',
  },
  INVALID_CLIENT_TYPE: {
    header: 'Ogiltig kundtyp',
    message: 'Den valda kundtypen är ogiltig.',
  },
  // Ekonomiflöde
  ORDER_COMPLETE_BILLING_REQUIRED: {
    header: 'Ärendet kunde inte slutföras',
    message: 'Slutförandet kräver ett val om ärendet ska faktureras vidare. Ladda om sidan och försök igen.',
  },
  ORDER_BILLING_PENDING_REVIEW: {
    header: 'Ärendet väntar på ekonomi',
    message: 'Ärendet måste faktureras eller avfärdas utan faktura i ekonomikön innan det kan klarmarkeras.',
  },
  ORDER_BILLING_COMPLETE_FIRST: {
    header: 'Ärendet kunde inte klarmarkeras',
    message: 'Ärendet måste slutföras innan det kan klarmarkeras.',
  },
  ORDER_BILLING_WRONG_STATE: {
    header: 'Ärendet kunde inte avfärdas',
    message: 'Ärendet väntar inte längre på ekonomigranskning. Ladda om sidan för att se aktuell status.',
  },
  ORDER_BILLING_SEND_WRONG_STATE: {
    header: 'Ärendet kunde inte skickas till ekonomikön',
    message: 'Ärendet måste vara slutfört, inte klarmarkerat och inte redan i ekonomiflödet. Ladda om sidan för att se aktuell status.',
  },
  ORDER_BILLING_WORKFLOW_DISABLED: {
    header: 'Ekonomiflödet är inte aktivt',
    message: 'Ekonomiflödet är inte aktiverat. Kontrollera klientinställningarna och att ekonomiintegrationen är aktiv.',
  },
  INVOICE_ROWS_ALREADY_INVOICED: {
    header: 'Raderna är redan fakturerade',
    message: 'Alla valda rapportrader ligger redan på en faktura och kan inte faktureras igen.',
  },
  INVOICE_PDF_NOT_AVAILABLE: {
    header: 'Ingen PDF tillgänglig',
    message: 'Fakturan saknar en sparad PDF i Björn Lundén och kan därför inte hämtas. Öppna och skriv ut fakturan i Björn Lundén först.',
  },
});

// For alert.show() and other places that need a plain text from an Apollo error.
export const getGraphqlErrorMessage = (error, fallback = defaultBody) => {
  const code = error?.graphQLErrors?.[0]?.extensions?.code;
  if (code && ERROR_MESSAGES[code]?.message) return ERROR_MESSAGES[code].message;
  return fallback;
};

const ErrorMessage = ({
  header: headerProp = defaultHeader,
  body: bodyProp = defaultBody,
  errorCode: errorCodeProp = null,
  graphqlError = null,
  modal = false,
  onModalClose = null,
}) => {
  // const [visible, setVisible] = useState(true);
  const hasGraphqlErrors = graphqlError && graphqlError.graphQLErrors && graphqlError.graphQLErrors.length > 0;
  let errorCode = errorCodeProp;
  if (hasGraphqlErrors) errorCode = graphqlError.graphQLErrors[0].extensions.code;

  let header = headerProp;
  let body = bodyProp;
  if (errorCode && ERROR_MESSAGES[errorCode]) {
    header = ERROR_MESSAGES[errorCode].header;
    body = ERROR_MESSAGES[errorCode].message;
  } else if (hasGraphqlErrors) {
    body = graphqlError.graphQLErrors[0].message;
  }

  // if (!visible) return null;

  const content = (
    <Message
      header={header}
      negative
      content={body}
    />
  );

  if (!modal) return content;

  return (
    <Modal defaultOpen closeIcon onClose={() => onModalClose && onModalClose()}>
      <Modal.Content>
        {content}
      </Modal.Content>
    </Modal>
  );
};

ErrorMessage.propTypes = {
  header: PropTypes.string,
  body: PropTypes.string,
  errorCode: PropTypes.string,
  modal: PropTypes.bool,
  graphqlError: PropTypes.shape({}),
  onModalClose: PropTypes.func,
};

export default ErrorMessage;
